<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import WhatsAppCampaignForm from './WhatsAppCampaignForm.vue';

const props = defineProps({
  selectedCampaign: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);
const formRef = ref(null);

const uiFlags = useMapGetter('campaigns/getUIFlags');
const isUpdating = computed(() => uiFlags.value.isUpdating);
const isFormInvalid = computed(() => formRef.value?.isFormInvalid ?? true);
const campaignId = computed(() => props.selectedCampaign?.id);

const handleConfirm = async () => {
  const isValid = await formRef.value?.validate();
  if (!isValid) return;

  const campaignDetails = formRef.value?.prepareCampaignDetails?.() || {};

  try {
    await store.dispatch('campaigns/update', {
      id: campaignId.value,
      ...campaignDetails,
    });
    useAlert(t('CAMPAIGN.WHATSAPP.EDIT.API.SUCCESS_MESSAGE'));
    dialogRef.value?.close();
  } catch (error) {
    useAlert(
      error?.response?.data?.message ||
        t('CAMPAIGN.WHATSAPP.EDIT.API.ERROR_MESSAGE')
    );
  }
};

const handleClose = () => {
  formRef.value?.resetToOriginal();
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('CAMPAIGN.WHATSAPP.EDIT.TITLE')"
    width="3xl"
    overflow-y-auto
    :is-loading="isUpdating"
    :disable-confirm-button="isUpdating || isFormInvalid"
    :confirm-button-label="t('CAMPAIGN.WHATSAPP.EDIT.CONFIRM')"
    @confirm="handleConfirm"
    @close="handleClose"
  >
    <WhatsAppCampaignForm
      ref="formRef"
      mode="edit"
      :selected-campaign="selectedCampaign"
    />
  </Dialog>
</template>
